import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/access';
import { CertificationsPage } from '@/features/certification/list-page';

export const Route = createFileRoute(
  '/_authenticated/operations/certifications',
)({
  beforeLoad: ({ context, location }) =>
    requirePermission(
      context.queryClient,
      location.href,
      'certifications:read',
    ),
  component: CertificationsPage,
});
